import EventIcon from '@mui/icons-material/Event';
import QueueIcon from '@mui/icons-material/Queue';
import GroupsIcon from '@mui/icons-material/Groups';
import SensorsIcon from '@mui/icons-material/Sensors';
import SettingsIcon from '@mui/icons-material/Settings';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import DashboardIcon from "@mui/icons-material/Dashboard";
import VisibilityIcon from '@mui/icons-material/Visibility';
import PostAddIcon from '@mui/icons-material/PostAdd';
import CalculateIcon from '@mui/icons-material/Calculate';
import PasswordIcon from '@mui/icons-material/Password';

export const mainNavbarItems = [
  {
    id: 0,
    icon: <DashboardIcon />,
    label: "Dashboard",
    route: "/web/dashboard",
    keyName: "manageDashboard"
  },
  {
    id: 1,
    icon: <GroupsIcon />,
    label: "User Management",
    route: "/web/roles",
    keyName: "manageUsers"
  },
  {
    id: 2,
    icon: <FileCopyIcon />,
    label: "File Management",
    route: "/web/firmware",
    keyName: "manageFirmware"
  },
  {
    id: 3,
    icon: <EventIcon />,
    label: "Event Tool Tips",
    route: "/web/tooltips",
    keyName: "manageEventTooltips"
  },
  {
    id: 4,
    icon: <VisibilityIcon />,
    label: "Change Logs",
    route: "/web/change-logs",
    keyName: "manageChangeLogs"
  },
  {
    id: 5,
    icon: <SensorsIcon />,
    label: "Remote Devices",
    route: "/web/connection-requests",
    keyName: "manageRemoteSocket"
  },
  {
    id: 6,
    icon: <PostAddIcon />,
    label: "Interpretation File",
    route: "/web/interpretation-files",
    keyName: "manageHomePageInterpretationFile"
  },
  {
    id: 7,
    icon: <CalculateIcon />,
    label: "Units & Enums",
    route: "/web/units",
    keyName: "manageUnitsAndEnums"
  },
  {
    id: 8,
    icon: <QueueIcon />,
    label: "Elevation Request",
    route: "/web/role/request",
    keyName: "requestEleveationRequest"
  },
  {
    id: 9,
    icon: <SettingsIcon />,
    label: "Elevation Management",
    route: "/web/role/request-list",
    keyName: "manageRequestEleveationRequest"
  },
  {
    id: 10,
    icon: <PasswordIcon />,
    label: "Passwords",
    route: "/web/passwords",
    keyName: "managePasswords"
  },
  
];



const enumsDataSet = {
  "enumGroups": [
    {"id": 0, "groupName": "None", "values": []},
    {
      "id": 1,
      "groupName": "EngineSequencerState",
      "values": [
        {"id": 0, "label": "Invalid"},
        {"id": 1, "label": "Stopped"},
        {"id": 2, "label": "Standby"},
        {"id": 3, "label": "ShutDown"},
        {"id": 4, "label": "WaitToStart"},
        {"id": 5, "label": "PeriodicLube"},
        {"id": 6, "label": "PreLubing"},
        {"id": 7, "label": "StarterEngaged"},
        {"id": 8, "label": "cranking"},
        {"id": 9, "label": "CrankPause"},
        {"id": 10, "label": "Running"},
        {"id": 11, "label": "CoolDown"},
        {"id": 12, "label": "Stopping"},
        {"id": 13, "label": "StoppedWithEcmPower"},
        {"id": 14, "label": "Stalled"}
      ]
    },
    {
      "id": 2,
      "groupName": "RedundantStarterMode",
      "values": [
        {"id": 0, "label": "Disabled"},
        {"id": 1, "label": "SwitchOnStart"}
      ]
    },
    {
      "id": 3,
      "groupName": "FuelType",
      "values": [
        {"id": 0, "label": "NaturalGas"},
        {"id": 1, "label": "LiquidPropane"},
        {"id": 2, "label": "Gasoline"},
        {"id": 3, "label": "Diesel"},
        {"id": 15, "label": "Unknown"}
      ]
    },
    {
      "id": 4,
      "groupName": "VoltagePhaseConnection",
      "values": [
        {"id": 0, "label": "SinglePhase"},
        {"id": 1, "label": "SinglePhaseDogleg"},
        {"id": 2, "label": "ThreePhaseWye"},
        {"id": 3, "label": "ThreePhaseDelta"}
      ]
    },
    {
      "id": 5,
      "groupNamelabel": "PowerApplicationMode",
      "values": [
        {"id": 0, "label": "Standby"},
        {"id": 1, "label": "Prime"}
      ]
    },
    {
      "id": 6,
      "groupNamelabel": "GenControllerState",
      "values": [
        {"id": 1, "label": "Init"},
        {"id": 2, "label": "Auto_Standby"},
        {"id": 4, "label": "Fault"},
        {"id": 5, "label": "Stop"},
        {"id": 6, "label": "Auto_Idle"},
        {"id": 7, "label": "Auto_Run"},
        {"id": 8, "label": "AutoCooldown"},
        {"id": 9, "label": "LPM"}
      ]
    },
    {
      "id": 7,
      "groupNamelabel": "OpenClosedBoolean",
      "values": [
        {"id": 0, "label": "Open"},
        {"id": 1, "label": "Closed"}
      ]
    },
    {
      "id": 8,
      "groupNamelabel": "YesNoBoolean",
      "values": [
        {"id": 0, "label": "No"},
        {"id": 1, "label": "Yes"}
      ]
    },
    {
      "id": 9,
      "groupNamelabel": "ActiveInactiveBoolean",
      "values": [
        {"id": 0, "label": "Inactive"},
        {"id": 1, "label": "Active"}
      ]
    },
    {
      "id": 10,
      "groupNamelabel": "OnOffBoolean",
      "values": [
        {"id": 0, "label": "Off"},
        {"id": 1, "label": "On"}
      ]
    },
    {
      "id": 11,
      "groupNamelabel": "LeadingLaggingNgc",
      "values": [
        {"id": 0, "label": "Leading"},
        {"id": 1, "label": "Lagging"}
      ]
    },
    {
      "id": 12,
      "groupNamelabel": "SensorSelect",
      "values": [
        {"id": 0, "label": "unused"},
        {"id": 1, "label": "Resistive"},
        {"id": 2, "label": "SwitchVal"},
        {"id": 3, "label": "CANsender"}
      ]
    },
    {
      "id": 13,
      "groupNamelabel": "ExerciseState",
      "values": [
        {"id": 0, "label": "NotStarted"},
        {"id": 1, "label": "Standby"},
        {"id": 2, "label": "Standby2"},
        {"id": 3, "label": "Standby3"},
        {"id": 4, "label": "Standby4"},
        {"id": 5, "label": "Running"},
        {"id": 6, "label": "Idle"},
        {"id": 7, "label": "Cancelled"},
        {"id": 8, "label": "Completed"}
      ]
    },
    {
      "id": 14,
      "groupNamelabel": "BaudRate",
      "values": [
        {"id": 0, "label": "None [NotUserVisible]"},
        {"id": 1, "label": "Bps9600 (9600)"},
        {"id": 2, "label": "Bps19200 (19200)"},
        {"id": 3, "label": "Bps38400 (38400)"},
        {"id": 4, "label": "Bps57600 (57600)"},
        {"id": 5, "label": "Bps115200 (115200)"}
      ]
    },
    {
      "id": 15,
      "groupNamelabel": "ChokeMode",
      "values": [
        {"id": 0, "label": "ChokeMode_QuarterOpen"},
        {"id": 1, "label": "ChokeMode_HalfOpen"},
        {"id": 2, "label": "ChokeMode_ThreeQuartersOpen"}
      ]
    }
  ]
};
 

export const getEnumOptionsById = (id) => {
  return enumsDataSet.enumGroups.find((group) => group.id === id);
};


export const genRequestId = () => {
  return (crypto?.randomUUID?.() ?? `req_${Date.now()}_${Math.random().toString(36).slice(2)}`);
}
